import bounceApiClient from 'legacy/common/utils/bounceApiClient';

import {
  IncomingCreateEventStandardProductDto,
  IncomingCreateEventBundleProductDto,
  OutgoingEventProductDto,
  OutgoingEventProductsDto,
  IncomingReorderProductsDto,
  IncomingUpdateEventStandardProductDto,
  IncomingUpdateEventBundleProductDto
} from 'api/dtos/events/products';

export async function createEventStandardProduct({
  eventId,
  product
}: {
  eventId: string;
  product: IncomingCreateEventStandardProductDto;
}): Promise<OutgoingEventProductDto> {
  const { data } = await bounceApiClient.post(
    `/api/events/${eventId}/products/standard`,
    product
  );

  return data;
}

export async function createEventBundleProduct({
  eventId,
  product
}: {
  eventId: string;
  product: IncomingCreateEventBundleProductDto;
}): Promise<OutgoingEventProductDto> {
  const { data } = await bounceApiClient.post(
    `/api/events/${eventId}/products/bundles`,
    product
  );

  return data;
}

export async function getEventProducts(
  eventId: string
): Promise<OutgoingEventProductsDto> {
  const { data } = await bounceApiClient.get(`/api/events/${eventId}/products`);

  return data;
}

export async function getEventProduct({
  eventId,
  productId
}: {
  eventId: string;
  productId: string;
}): Promise<OutgoingEventProductDto> {
  const { data } = await bounceApiClient.get(
    `/api/events/${eventId}/products/${productId}`
  );

  return data;
}

export async function updateEventStandardProduct({
  eventId,
  productId,
  product
}: {
  eventId: string;
  productId: string;
  product: IncomingUpdateEventStandardProductDto;
}): Promise<OutgoingEventProductDto> {
  const { data } = await bounceApiClient.put(
    `/api/events/${eventId}/products/standard/${productId}`,
    product
  );

  return data;
}

export async function updateEventBundleProduct({
  eventId,
  productId,
  product
}: {
  eventId: string;
  productId: string;
  product: IncomingUpdateEventBundleProductDto;
}): Promise<OutgoingEventProductDto> {
  const { data } = await bounceApiClient.put(
    `/api/events/${eventId}/products/bundles/${productId}`,
    product
  );

  return data;
}

export async function deleteEventProduct({
  eventId,
  productId
}: {
  eventId: string;
  productId: string;
}): Promise<void> {
  await bounceApiClient.delete(`/api/events/${eventId}/products/${productId}`);
}

export async function reorderEventProducts({
  eventId,
  data
}: {
  eventId: string;
  data: IncomingReorderProductsDto;
}): Promise<void> {
  await bounceApiClient.post(`/api/events/${eventId}/products/reorder`, data);
}

export async function getUnauthenticatedEventProducts(
  eventId: string
): Promise<OutgoingEventProductsDto> {
  const { data } = await bounceApiClient.get(
    `/service/events/${eventId}/products`
  );

  return data;
}
